import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { careersApi } from '@/api/endpoints/careers';
import type { JobInput, ApplicationFilters, ApplicationStatus } from '@/api/endpoints/careers';

// ----- Vagas -----

export const useJobs = () =>
  useQuery({
    queryKey: ['careers-jobs'],
    queryFn: careersApi.listJobs,
    staleTime: 1000 * 30,
    retry: 1,
  });

export const useCreateJob = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: JobInput) => careersApi.createJob(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['careers-jobs'] }),
  });
};

export const useUpdateJob = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: JobInput }) => careersApi.updateJob(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['careers-jobs'] }),
  });
};

export const useDeleteJob = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => careersApi.deleteJob(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['careers-jobs'] }),
  });
};

// ----- Candidaturas -----

export const useApplications = (filters: ApplicationFilters) =>
  useQuery({
    queryKey: ['careers-applications', filters],
    queryFn: () => careersApi.listApplications(filters),
    staleTime: 1000 * 30,
    retry: 1,
  });

export const useUpdateApplicationStatus = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, status }: { id: number; status: ApplicationStatus }) =>
      careersApi.updateApplicationStatus(id, status),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['careers-applications'] }),
  });
};
